<template>
    <div class="cet-partner-logos">
        <div class="item-container" v-for="(partner, index) in partnersMix" :key="index">
            <div class="item">
                <a :href="partner.url" target="_blank">
                    <div class="item-content">
                        <img class="logo" :src="partner.image" :alt="partner.name">
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

        data() {
            return {
                partners: [
                    {url: 'https://www.nlcaa.org', image: '/images/partners/nlcaa.png', name: 'NLCAA'},
                    {url: 'http://www.lutron.com', image: '/images/partners/lutron.png', name: 'Lutron'},
                    {url: 'https://www.nlight.net', image: '/images/partners/nlight.jpg', name: 'nLight'},
                    {url: 'https://www.nfpa.org', image: '/images/partners/nfpa.png', name: 'NFPA'},
                    {url: 'https://www.mikeholt.com', image: '/images/partners/mh.png', name: 'Mike Holt'},
                    {url: 'https://www.osha.gov', image: '/images/partners/osha.png', name: 'OSHA'},
                    {url: 'https://www.leviton.com', image: '/images/partners/leviton.png', name: 'Leviton'},
                    {url: 'https://www.walterswholesale.com', image: '/images/partners/walters.png', name: 'Walters'},
                    {url: 'https://performanceltg.com/', image: '/images/partners/performance.png', name: 'Performance Lighting Systems'},
                    {url: 'https://westernlightingandenergycontrols.com/', image: '/images/partners/western.png', name: 'Western Lighting & Energy Controls'},
                ]
            }
        },

        computed: {
            partnersMix() {
                return _.shuffle(this.partners)
            }
        }
    }
</script>
